// extracted by mini-css-extract-plugin
export default {"mag_home_sliders_container":"sliders-tab_mag_home_sliders_container__mwAoX"};